import styled, { css, keyframes } from 'styled-components';

import { elevationTokens, colorTokens } from '../../../tokens/globals/tokens';

import { newDatePickerTokens } from '../../../tokens/components/NewDatePicker/tokens';

const calendarSectionWidth = 250;
const arrowWidth = 16;
const arrowBorderWidth = 1;
const arrowLeft = (calendarSectionWidth - arrowWidth) / 2;
const arrowRight = 10;

const dropdownIn = keyframes`
  0% { transform: translateY(-0.25rem); }
  60% { transform: translateY(-0.05rem); }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const CalendarContainer = styled.div<{ align: 'right' | 'left' | undefined }>`
  box-shadow: 0 4px 12px 1px rgba(0, 0, 0, 0.08);
  background-color: ${colorTokens.GlobalBrandWhite};
  border: 1px solid ${colorTokens.GlobalBrandGray30};
  border-radius: ${newDatePickerTokens.ContainerBorderRadiusBaseDefault};
  color: ${colorTokens.GlobalBrandBlack};
  display: block;
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  z-index: ${elevationTokens.GlobalCalendar};
  animation: ${dropdownIn} 150ms ease-out forwards;

  /* Arrow */
  &::after,
  &::before {
    border: solid transparent;
    bottom: 100%;
    content: '';
    height: 0;
    pointer-events: none;
    position: absolute;
    width: 0;
  }

  /* Arrow content */
  &::after {
    border-bottom-color: ${colorTokens.GlobalBrandWhite};
    border-width: ${arrowWidth / 2}px;
    left: ${arrowLeft}px;
  }

  /* Arrow border */
  &::before {
    border-bottom-color: ${colorTokens.GlobalBrandGray30};
    border-width: ${arrowWidth / 2 + arrowBorderWidth}px;
    left: ${arrowLeft - arrowBorderWidth}px;
  }

  ${props =>
    props.align === 'right' &&
    css`
      left: auto;
      right: 0;

      /* Arrow */
      &::after {
        left: auto;
        right: ${arrowRight}px;
      }
      &::before {
        left: auto;
        right: ${arrowRight - arrowBorderWidth}px;
      }
    `}
`;

export const CalendarBody = styled.div`
  display: flex;
`;

export const CalendarSection = styled.div`
  padding: 8px 8px;
  width: ${calendarSectionWidth}px;
`;
